import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PageHeader = styled('div', {
  base: {},
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const DocumentList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const DocumentRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

const DocumentInfo = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const DocumentName = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const DocumentMeta = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
    textTransform: 'capitalize',
  },
})

const DownloadLink = styled('a', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    paddingX: '14px',
    paddingY: '8px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      opacity: '0.85',
    },
  },
})

export {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  QuietText,
  DocumentList,
  DocumentRow,
  DocumentInfo,
  DocumentName,
  DocumentMeta,
  DownloadLink,
}
